export default class Team {
    static fromData(data) {
        if (!data) {
            return;
        }

        let team = new Team();
        team.id = data.id || null;
        team.name = data.name || '';
        team.departmentName = data.departmentName || null;
        team.departmentId = data.departmentId || null;
        team.hideMembersFromEachOther = data.hideMembersFromEachOther || false;
        team.enableChat = data.enableChat || false;
        team.isBasicDataViewable = data.isBasicDataViewable || false;
        team.isBasicDataEditable = data.isBasicDataEditable || false;
        team.isDeletable = data.isDeletable || false;
        team.hasImage = data.hasImage || false;
        team.imageUrl = data.imageUrl || null;
        team.sportId = data.sportId || null;
        team.sportName = data.sportName || null;

        return team;
    }

    static create(departmentId = null, departmentName = null) {
        let team = new Team();
        team.id = null;
        team.name = '';
        team.departmentName = departmentName;
        team.departmentId = departmentId;
        team.hideMembersFromEachOther = false;
        team.enableChat = false;
        team.isBasicDataViewable = true;
        team.isBasicDataEditable = true;
        team.isDeletable = false;
        team.hasImage = false;
        team.imageUrl = null;
        team.sportId = null;
        team.sportName = null;

        return team;
    }

    extendedName() {
        return `${this.name} (${this.departmentName})`;
    }

    makeEditable() {
        this.isBasicDataEditable = true;
    }
}
